module.exports = __webpack_public_path__ + "static/media/dekton.a241c7a7.svg";